import "./index.less";
import React from "react";
import ReactDOM from "react-dom";
import {
    registerMicroApps,
    start,
    initGlobalState,
    MicroAppStateActions,
} from "qiankun";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "@/store";
import App from "./App";
import { APP_PORTAL } from "./interface";

import { xhrHandler } from "@jd/sso-oidc-web";

xhrHandler(401, "oidc.code");

const isDevelopment =
    process.env.REACT_APP_ENV === "development" ||
    process.env.REACT_APP_ENV === "gray";

export const actions: MicroAppStateActions = initGlobalState({
    activitePath: "",
    activiteUrl: "",
});

let menuType = localStorage.getItem("crmUserMenu");
const selectOrg = localStorage.getItem("selectOrgCode");

if (menuType === null || menuType === "&old=true") {
    localStorage.setItem("crmUserMenu", "?old=true");
    menuType = "?old=true";
}

const subApp = [
    {
        name: "bd",
        entryDev: "/crm-admin-ts/",
        entryProd: "/crm-admin-ts/",
        activeRule: "/bd",
        base: "/bd-crm/",
        match: "crms.jd.com",
    },
    // {
    //     name: "gongdan",
    //     entryDev: "/gongdan/",
    //     entryProd: "/gongdan/",
    //     activeRule: "/gongdan",
    //     base: "/bd-gongdan/",
    //     match: "gongdan",
    // },
    // {
    //   name: "bdCrm",
    //   entryDev: "https://bd-crm.jd.com/",
    //   entryProd: "/bd-crm/",
    //   activeRule: "/bd-map",
    //   base: "/bdCrm/",
    // },
    // {
    //   name: "newCrm",
    //   entryDev: "https://new-crm.jd.com/",
    //   entryProd: "/new-crm/",
    //   activeRule: "/new-crm",
    //   base: "/newCrm/",
    // },
];

const apps = subApp.map((item) => {
    return {
        ...item,
        name: item.name,
        container: "#micro-container",
        // entry: isDevelopment ? item.entryDev : item.entryProd, // 得与子项目的 publicPath 相关联
        entry: isDevelopment ? item.entryProd : item.entryDev, // 得与子项目的 publicPath 相关联
        activeRule: item.activeRule, // 得与子项目的路由前缀保持一致
    };
});

registerMicroApps(apps, {
    // @ts-ignore
    beforeLoad: (app) => console.log("before load", app.name),
    // @ts-ignore
    beforeMount: [(app) => console.log("before mount", app.name)],
});

const subAppMap: any = {};
apps.forEach((app) => (subAppMap[app.match] = app));

store.dispatch({
    type: "setSubAppList",
    value: subApp || [],
});
store.dispatch({
    type: "setSubAppMap",
    value: subAppMap || {},
});

start({
    prefetch: false,
    singular: true,
    // 过滤 运营商动态插入的脚本
    excludeAssetFilter: (assetsUrl) => {
        const whiteList: string[] = [];
        const whiteWord: string[] = [
            "map.qq.com",
            "baidu.com",
            " .com",
            "bdstatic.com",
        ];
        console.log(assetsUrl, "assetsUrl");
        if (whiteList.includes(assetsUrl)) {
            return true;
        }
        return whiteWord.some((word) => assetsUrl.includes(word));
    },
});

const CRM_XnWorkbench_Code = {};
const evnPreFix = APP_PORTAL.CRM;

let styleSheet = document.createElement("link");
styleSheet.href = `/styles/${evnPreFix}.css`;
styleSheet.rel = "stylesheet";
styleSheet.type = "text/css";

document.getElementsByTagName("head")[0].appendChild(styleSheet);

ConfigProvider.config({
    prefixCls: evnPreFix, // 4.13.0+
});
const render = () =>
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <ConfigProvider prefixCls={evnPreFix}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ConfigProvider>
            </Provider>
        </React.StrictMode>,
        document.getElementById("microMainContainer")
    );
render();
